import React, { Component } from "react";
import { connect } from "react-redux";
import { getDigiLockerVerfication, getEntityLockerVerification } from "../../actions/accountAction";

class VerifyProfile extends Component {

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const errorParam = urlParams.get("error");

        // DigiLocker redirects back here after logout with error=user_loggedout — send user to signup
        if (errorParam === "user_loggedout" || localStorage.getItem("digi_logout_bouncing") === "true") {
            localStorage.removeItem("digi_logout_bouncing");
            const bounceType = localStorage.getItem("digi_bounce_type") || "1";
            localStorage.removeItem("digi_bounce_type");
            window.location.href = `${window.location.origin}/signup?type=${bounceType}`;
            return;
        }

        const code = urlParams.get("code");
        const action = urlParams.get("action");
        const code_verifier = urlParams.get("code_verifier");

        // Entity Locker return: user entered GST on signup and went through Entity Locker; redirect back to signup after verification
        const signupViaEntityLocker = localStorage.getItem("signup_via_entitylocker") === "true";
        if (signupViaEntityLocker && code) {
            this.props.getEntityLockerVerification();
            return;
        }

        // Store all params so API has them even if called again (e.g. from componentDidUpdate)
        if (code) localStorage.setItem("digi_code", code);
        if (code_verifier) localStorage.setItem("digi_code_verifier", code_verifier);
        if (action) localStorage.setItem("digi_action", action);

        // Only call verification when we have the auth code (from URL or previously stored)
        if (code || localStorage.getItem("digi_code")) {
            this.props.getDigiLockerVerfication();
        }
    }

    componentDidUpdate(prevProps) {
        const { actionReducer } = this.props;
        const currentDigi = actionReducer?.digiVerification;
        const currentEntity = actionReducer?.entityVerification;
        const prevEntity = prevProps.actionReducer?.entityVerification;

        // Entity Locker: after successful verification, go to signup so user sees verification there (GST match is checked on signup)
        const entitySuccess = currentEntity && (
            currentEntity.is_verified === true ||
            (currentEntity.success === true && String(currentEntity.status) === "200")
        );
        if (entitySuccess && !(prevEntity && (prevEntity.is_verified === true || (prevEntity.success === true && String(prevEntity.status) === "200")))) {
            window.location.href = `${window.location.origin}/signup?type=6`;
            return;
        }

        // DigiLocker: after success, redirect to logout then signup
        if (currentDigi?.success === true && String(currentDigi?.status) === "200") {
            localStorage.setItem("digi_logout_bouncing", "true");
            localStorage.setItem("digi_bounce_type", localStorage.getItem("digi_signup_type") || "1");
            window.location.href =
                "https://digilocker.meripehchaan.gov.in/signin/logout/Y";
        }
    }


    render() {
        const { actionReducer } = this.props;
        const digiVerification = actionReducer?.digiVerification;
        const entityVerification = actionReducer?.entityVerification;
        const loading = actionReducer?.loading;
        const error = actionReducer?.error;
        const isEntityLockerFlow = localStorage.getItem("signup_via_entitylocker") === "true";

        const showEntity = isEntityLockerFlow || entityVerification != null;
        const entityError = entityVerification?.error;
        const entitySuccess = entityVerification && (
            entityVerification.is_verified === true ||
            (entityVerification.success === true && String(entityVerification.status) === "200")
        );

        return (
            <div className="container mt-5 text-center">
                <h2>{showEntity ? "Entity Locker Verification" : "DigiLocker Verification"}</h2>

                {loading && <p>Verifying...</p>}

                {showEntity ? (
                    <>
                        {entitySuccess && (
                            <div className="alert alert-success mt-3 verificater">
                                Verification Successful
                            </div>
                        )}
                        {(entityError || (error && !digiVerification)) && (
                            <div className="alert alert-danger mt-3">
                                {entityError || error}
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        {digiVerification?.success && (
                            <div className="alert alert-success mt-3 verificater">
                                Verification Successful
                            </div>
                        )}
                        {error && (
                            <div className="alert alert-danger mt-3">
                                {error}
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    actionReducer: state.actionReducer,
});

export default connect(
    mapStateToProps,
    { getDigiLockerVerfication, getEntityLockerVerification }
)(VerifyProfile);